<h2 class="scene-bank-header">Scene Layouts</h2>

<div *ngIf="design && personalizedDynamics && this.localCompositions?.length > 0" class="categories">
    <ng-container *ngFor="let sceneCategory of localCompositions">
        <div *ngIf="sceneCategory.compositionsAndStagePositions.length > 0" class="scene-category">
            <h4 class="scene-category-title">{{ sceneCategory.name }}</h4>
            <div class="scene-grid">
                <div
                    *ngFor="let sceneComposition of sceneCategory.compositionsAndStagePositions"
                    class="composition-cell"
                    [class]="{
                        'aspect-169': aspectRatio === AspectRatioEnum._16x9,
                        'aspect-11': aspectRatio === AspectRatioEnum._1x1,
                        'aspect-916': aspectRatio === AspectRatioEnum._9x16,
                    }">
                    <div
                        class="composition-area-wrapper"
                        [class.selected]="sceneComposition.composition._id === chosenComposition?._id"
                        (click)="chooseComposition(sceneComposition.composition)">
                        <div class="composition-area" [style.aspect-ratio]="aspectRatio">
                            <app-silhouette
                                *ngIf="sceneComposition.stagePositions.length > 0"
                                [stagePositions]="sceneComposition.stagePositions">
                            </app-silhouette>

                            <dynamic-lottie
                                [config]="{
                                    layout: sceneComposition.composition.layouts[0],
                                    dynamicLottieChanges: personalizedDynamics,
                                }">
                            </dynamic-lottie>
                        </div>
                        <h5 class="composition-name">{{ sceneComposition.composition.name }}</h5>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>

<div class="buttons-area" mat-dialog-actions align="end">
    <button mat-dialog-close mat-raised-button (click)="closeDialog()">Cancel</button>
    <button
        color="primary"
        mat-raised-button
        (click)="onConfirmClickedAsync()"
        mat-raised-button
        [class.button-loading-spinner]="this.isLoadingNewScene">
        <span *ngIf="!this.isLoadingNewScene">Choose</span>
    </button>
</div>
